import { DSFilterToCRMSearch, DSFilterFromCRMSearch } from 'customer-data-filters-ui/converters/Converters';
import { CrmSearch, SalesViews } from 'customer-data-filters-ui/filterQueryFormat/strategy/StrategyTypes';
import { getCRMSearchOperatorsForType, getSalesViewsOperatorsForType } from '../converters/crmSearch/CRMSearchTypeToOperator';
import I18n from 'I18n';
import { validateCondition } from '../utils/conditionValidation';
import { fetchAppObjectDefinitions, fetchAssociationDefinitions, fetchCustomObjectDefinitions, fetchDataForSelectedFilters, fetchStandardObjectDefinitions, getFilterFamilyObjectName, getObjectAssociationOptions, makeGetFilterFamilyTranslationKey } from './strategyUtils';
import { List, Map as ImmutableMap, OrderedMap } from 'immutable';
import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PropertyGroupRecord from 'customer-data-objects/property/PropertyGroupRecord';
import { getFilteredFieldsWithMagicFields, unwrapSingleCRMFilter, wrapSingleCRMFilter } from './crmSearchStrategyUtils';
import { isMagicField } from './crmSearchStrategyUtils';
import getIn from 'transmute/getIn';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { AUTOMATION_PLATFORM_WORKFLOWS, BUSINESS_UNIT, CONTACT_LIST, DEAL_PIPELINE_STAGE, DEAL_PIPELINE, FORM, HIERARCHICAL_TEAM, INBOUND_DB_IMPORT, INBOUND_DB_LISTS, MARKETING_EVENT_APP_NAME, MULTI_CURRENCY_CURRENCY_CODE, OWNER, PERSONA, SALESFORCE_CAMPAIGN, SEQUENCE, TICKET_PIPELINE, TICKET_STAGE, CALL_DISPOSITION, USER
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
} from 'reference-resolvers/constants/ReferenceObjectTypes';
import * as ExternalOptionTypes from 'customer-data-objects/property/ExternalOptionTypes';
import { getMeOption, getDeactivatedOwersOption, getMyTeamOption, getMyUserIdOption } from '../utils/specialFieldUtils';
import { getAllClosedWonOption } from 'customer-data-objects/deal/DealStageIdOptions';
import { getAllClosedOption } from 'customer-data-objects/ticket/TicketStageIdOptions';
import { Equal } from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import always from 'transmute/always';
import { makeGetFilterFamilyEntityName } from 'customer-data-filters-ui/strategy/strategyUtils';
import unescapedText from 'I18n/utils/unescapedText';
import { getEditorFilterFamilyNameTranslation } from 'customer-data-filters-ui/utils/filterFamilyTranslationConfig';
import { StrategyBase } from './StrategyBase';
import { deepFreeze } from '../utils/utils';
import ListMembershipsProperty from 'customer-data-objects/property/special/ListMembershipsProperty';
import { toDSFieldRecord } from '../public/core';
import { PROPERTY_RECORD } from '../filterQueryFormat/DSFieldRecord/formatter/FormatTypes';
import { getCRMSearchFieldDefinitionsForFilterFamily } from '../converters/crmSearch/fieldDefinitions/CRMSearchFieldDefinitions';
import { hasAllDeactivatedOwnersFilter } from '../permissions/gates';
import { CATEGORY_KEYS } from '../components/dataExplorer/categorySelection/Categories';
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { STRING } from 'customer-data-objects/property/PropertyTypes';
export const onMount = (props, requiredIdsByAssetFamily) => {
  const {
    fetchMore,
    baseFilterFamily
  } = props;
  const requests = [fetchStandardObjectDefinitions(fetchMore), fetchDataForSelectedFilters(fetchMore, requiredIdsByAssetFamily), fetchAssociationDefinitions(fetchMore, baseFilterFamily), fetchCustomObjectDefinitions(fetchMore), fetchAppObjectDefinitions(fetchMore)];
  return Promise.all(requests);
};
export const onEditorMount = () => {
  return Promise.resolve();
};
export const getFilterFamilyName = (filterFamily, props) => {
  const getFilterFamilyEntityName = makeGetFilterFamilyEntityName(props);
  const getFilterFamilyTranslationKey = makeGetFilterFamilyTranslationKey(props.baseFilterFamily, false);
  const translationConfig = getEditorFilterFamilyNameTranslation(filterFamily, {
    getFilterFamilyEntityName,
    getFilterFamilyTranslationKey
  });
  return unescapedText(translationConfig.key, translationConfig.options);
};
export const getFilterFamilyGroupHeading = () => undefined;
export const getFilterFamilyOptions = props => {
  const options = [{
    category: CATEGORY_KEYS.PROPERTIES,
    text: I18n.text('newCustomerDataFilters.FilterFamilyGroup.currentObject'),
    options: [{
      text: getFilterFamilyName(props.baseFilterFamily, props),
      value: props.baseFilterFamily
    }]
  }];
  return options;
};
export const getFields = (filterFamily, props, includeAssociations = false) => {
  const {
    getIsUngated,
    hasScope,
    data
  } = props;
  return getFilteredFieldsWithMagicFields(filterFamily, data, includeAssociations, hasScope, getIsUngated);
};
export const getField = (filterFamily, id, defaultField, props) => {
  // We don't provide this property in the fields so we
  // need a hard coded case to resolve this in existing filters until the
  // views BE runs a migration to convert all views with filtering using this
  // property to the ILS variant
  if (filterFamily === CONTACT_TYPE_ID && id === ListMembershipsProperty.name) {
    const ListMembershipsField = toDSFieldRecord(ImmutableMap({
      [ListMembershipsProperty.name]: ListMembershipsProperty
    }), filterFamily, PROPERTY_RECORD).first();
    return ListMembershipsField;
  }
  const allFields = getFields(filterFamily, props, true);
  return getIn([id], allFields) || defaultField;
};
const getFieldGroups = (filterFamily, props) => {
  const {
    data
  } = props;
  const allFields = getFields(filterFamily, props, false);
  const groups = ((data === null || data === void 0 ? void 0 : data.getIn([DSAssetFamilies.PROPERTY_GROUP, filterFamily])) || OrderedMap()).filter(group => group.name);
  const groupedFields = allFields.groupBy(field => field.groupName);
  return groups.map((group, groupName) => PropertyGroupRecord({
    displayOrder: group.displayOrder,
    displayName: group.label || group.name,
    name: group.name,
    properties: (groupedFields.get(groupName) || OrderedMap()).toList()
  }));
};
export const getReferenceResolvers = resolvers => {
  return ImmutableMap({
    [ExternalOptionTypes.INBOUND_DB_IMPORT]: resolvers.get(INBOUND_DB_IMPORT),
    [ExternalOptionTypes.INBOUND_DB_LIST]: resolvers.get(INBOUND_DB_LISTS),
    AUTOMATION_PLATFORM_WORKFLOWS: resolvers.get(AUTOMATION_PLATFORM_WORKFLOWS),
    BUSINESS_UNIT: resolvers.get(BUSINESS_UNIT),
    DEAL_PIPELINE: resolvers.get(DEAL_PIPELINE),
    DEAL_STAGE: resolvers.get(DEAL_PIPELINE_STAGE),
    FORM: resolvers.get(FORM),
    LIST: resolvers.get(CONTACT_LIST),
    MARKETING_EVENT_APP_NAME: resolvers.get(MARKETING_EVENT_APP_NAME),
    MULTI_CURRENCY_CURRENCY_CODE: resolvers.get(MULTI_CURRENCY_CURRENCY_CODE),
    OWNER: resolvers.get(OWNER),
    PERSONA: resolvers.get(PERSONA),
    SALESFORCE_CAMPAIGN: resolvers.get(SALESFORCE_CAMPAIGN),
    SEQUENCE: resolvers.get(SEQUENCE),
    TEAM: resolvers.get(HIERARCHICAL_TEAM),
    TICKET_PIPELINE: resolvers.get(TICKET_PIPELINE),
    TICKET_STAGE: resolvers.get(TICKET_STAGE),
    CALL_DISPOSITION: resolvers.get(CALL_DISPOSITION),
    USER: resolvers.get(USER)
  });
};
const getSpecialFieldsForOwner = () => {
  return hasAllDeactivatedOwnersFilter() ? List.of(getMeOption(), getDeactivatedOwersOption()) : List.of(getMeOption());
};
export const getSpecialFieldOptions = () => ({
  OWNER: () => getSpecialFieldsForOwner(),
  DEAL_STAGE: () => List.of(getAllClosedWonOption()),
  TICKET_STAGE: () => List.of(getAllClosedOption())
});
export const getIsRollingDateOffsetInputEnabled = hasScope => {
  return hasScope('bet-views-rollingoffset-filtering');
};
export const serializer = {
  fromFormat: DSFilterFromCRMSearch,
  toFormat: DSFilterToCRMSearch
};
export const validateConditionForCRMSearch = (operator, getIsUngated, options) => {
  // do not validate association filters for now, once they are using one virtual property this should be easier to handle
  if (operator && operator.field && operator.field.name && operator.field.name.indexOf('associations.') === 0 && operator.constructor === Equal) {
    return operator;
  }
  return validateCondition(operator, getIsUngated, options);
};
// Soon this should be replaced with SalesViewsStrategy, keeping for reverse compatibility
export class CRMSearchStrategy extends StrategyBase {
  configure(customConfig) {
    const newStrategy = new CRMSearchStrategy(this.strategyDefinition);
    newStrategy.applyCustomConfig(customConfig);
    return deepFreeze(newStrategy);
  }
}

// This version does not allow for the use Placeholders that the sales views api supports
// This should be renamed to CRMSearchStrategy once the correct apps are using the SalesViewsStrategy
export class CRMSearchStrategyWithoutPlaceholders extends StrategyBase {
  configure(customConfig) {
    const newStrategy = new CRMSearchStrategyWithoutPlaceholders(this.strategyDefinition);
    newStrategy.applyCustomConfig(customConfig);
    return deepFreeze(newStrategy);
  }
}
export const CRMSearchStrategyWithoutPlaceholdersInstance = deepFreeze(new CRMSearchStrategyWithoutPlaceholders({
  onMount,
  onEditorMount,
  getField,
  getFieldDefinitions: getCRMSearchFieldDefinitionsForFilterFamily,
  getFieldGroups,
  getFields,
  getFilterFamilyOptions,
  getFilterFamilyName,
  getFilterFamilyObjectName,
  getFilterFamilyGroupHeading,
  getObjectAssociationOptions,
  getOperatorsForType: getCRMSearchOperatorsForType,
  getReferenceResolvers,
  getSpecialFieldOptions: () => ({}),
  serializer,
  wrapSingleFilter: wrapSingleCRMFilter,
  unwrapSingleFilter: unwrapSingleCRMFilter,
  strategyType: CrmSearch,
  validateOperator: validateConditionForCRMSearch,
  getIsFiscalYearEnabled: always(false),
  getIsRollingDateOffsetInputEnabled,
  isMagicField
}));

// this will replace be used by apps that need placeholders
export class SalesViewsStrategy extends CRMSearchStrategyWithoutPlaceholders {
  configure(customConfig) {
    const newStrategy = new SalesViewsStrategy(this.strategyDefinition);
    newStrategy.applyCustomConfig(customConfig);
    return deepFreeze(newStrategy);
  }
}
export const SalesViewsStrategyInstance = deepFreeze(new CRMSearchStrategy({
  onMount,
  onEditorMount,
  getField,
  getFieldDefinitions: getCRMSearchFieldDefinitionsForFilterFamily,
  getFieldGroups,
  getFields,
  getFilterFamilyOptions,
  getFilterFamilyName,
  getFilterFamilyObjectName,
  getFilterFamilyGroupHeading,
  getObjectAssociationOptions,
  getOperatorsForType: getSalesViewsOperatorsForType,
  getReferenceResolvers,
  getSpecialFieldOptions,
  serializer,
  wrapSingleFilter: wrapSingleCRMFilter,
  unwrapSingleFilter: unwrapSingleCRMFilter,
  strategyType: SalesViews,
  validateOperator: validateConditionForCRMSearch,
  getIsFiscalYearEnabled: always(true),
  getIsRollingDateOffsetInputEnabled,
  isMagicField
}));
export class ReportingCRMSearchStrategy extends CRMSearchStrategy {
  configure(customConfig) {
    const newStrategy = new ReportingCRMSearchStrategy(this.strategyDefinition);
    newStrategy.applyCustomConfig(customConfig);
    return deepFreeze(newStrategy);
  }
}
export const ReportingCRMSearchStrategyInstance = deepFreeze(new ReportingCRMSearchStrategy({
  onMount,
  onEditorMount,
  getField,
  getFieldDefinitions: getCRMSearchFieldDefinitionsForFilterFamily,
  getFieldGroups,
  getFields,
  getFilterFamilyOptions,
  getFilterFamilyName,
  getFilterFamilyObjectName,
  getFilterFamilyGroupHeading,
  getObjectAssociationOptions,
  getOperatorsForType: getCRMSearchOperatorsForType,
  getReferenceResolvers,
  getSpecialFieldOptions: () => ({
    OWNER: () => getSpecialFieldsForOwner(),
    DEAL_STAGE: () => List.of(getAllClosedWonOption()),
    TEAM: () => List.of(getMyTeamOption()),
    USER: () => List.of(getMyUserIdOption())
  }),
  serializer,
  wrapSingleFilter: wrapSingleCRMFilter,
  unwrapSingleFilter: unwrapSingleCRMFilter,
  strategyType: CrmSearch,
  validateOperator: validateConditionForCRMSearch,
  getIsFiscalYearEnabled: always(true),
  getIsRollingDateOffsetInputEnabled,
  isMagicField
}));
const getFiltersBackendCRMPlusOperatorsForType_doNotUse = (type, filterFamily, isUngated, options) => {
  const base = getCRMSearchOperatorsForType(type, filterFamily, isUngated, options);
  if (base && base.size > 0) {
    if (type === STRING) {
      return base.add(Operators.StartsWith).add(Operators.EndsWith);
    }
  }
  return base;
};
export const FitlerBackendCRMPlusStrategy_doNotUse = deepFreeze(new CRMSearchStrategy({
  onMount,
  onEditorMount,
  getField,
  getFieldDefinitions: getCRMSearchFieldDefinitionsForFilterFamily,
  getFieldGroups,
  getFields,
  getFilterFamilyOptions,
  getFilterFamilyName,
  getFilterFamilyObjectName,
  getFilterFamilyGroupHeading,
  getObjectAssociationOptions,
  getOperatorsForType: getFiltersBackendCRMPlusOperatorsForType_doNotUse,
  getReferenceResolvers,
  getSpecialFieldOptions,
  serializer,
  wrapSingleFilter: wrapSingleCRMFilter,
  unwrapSingleFilter: unwrapSingleCRMFilter,
  strategyType: SalesViews,
  validateOperator: validateConditionForCRMSearch,
  getIsFiscalYearEnabled: always(true),
  getIsRollingDateOffsetInputEnabled
}));